import { writable } from "svelte/store";
import * as api from "../apis/dspMng.api";

export async function apiGetDspMng(item_code) {
    try {
        const response = await api.apiGetDspMng(item_code);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiGetDspMngDetail() {
    try {
        const response = await api.apiGetDspMngDetail();

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiPostDspMng(
    dlivy_no,
    dlivy_de,
    wrhous_code,
    wrhous_lclas_code,
    wrhous_mlsfc_code,
    wrkshp_code,
    barcodeList
) {
    try {
        let formData = {
            dlivy_no: dlivy_no,
            dlivy_de: dlivy_de,
            wrhous_code: wrhous_code,
            wrhous_lclas_code: wrhous_lclas_code,
            wrhous_mlsfc_code: wrhous_mlsfc_code,
            wrkshp_code: wrkshp_code,
            barcodeList: barcodeList,
        };

        const response = await api.apiPostDspMng(formData);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return true;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiGetDspList(sdate, edate) {
    try {
        const response = await api.apiGetDspList(sdate, edate);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}
